export default {
    state: {
        dateNow: new Date(0)
    },
    getters:{
        dateNow: state => state.dateNow
    },
    mutations: {
        _setClockDate(state, date){
            state.dateNow = date;
        },
    },
    actions:{
        initClock({commit}){
            setInterval(setClockDate, 1000);
            function setClockDate(){
                commit('_setClockDate', new Date());
            }
        }
    }
}